import { InputAdornment } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import TextField from '@material-ui/core/TextField';
import React, { Component } from 'react';

class PasswordInput extends Component {
    state = {
        passwordIsMasked: true
    }

    togglePasswordMask = () => {
        this.setState((state) => {
            return {
                passwordIsMasked: !state.passwordIsMasked
            }
        });
    }

    render() {
        const { passwordIsMasked } = this.state;

        const inputProps = {
            endAdornment: (
                <InputAdornment position="end" style={{cursor: 'pointer'}}>
                    { passwordIsMasked ? <Visibility onClick={this.togglePasswordMask} /> : <VisibilityOff onClick={this.togglePasswordMask} /> }
                </InputAdornment>
            )
        };

        return (
            <TextField 
                {...this.props} 
                type={passwordIsMasked ? 'password' : 'text'} 
                InputProps={inputProps}
            />
        );
    }
}

export default PasswordInput;